import { createSlice } from '@reduxjs/toolkit'

export const slice = createSlice({
  name: 'threads',
  initialState: {
    threads: {},
    currentFilter: {},
    pages: {
      all: {},
      text: {},
      box: {},
      label: {},
      promotional: {},
      spam: {},
      pinned: {},
      deleted: {},
      sent: {},
      archived: {},
      'no-label': {},
    },
    filteringMode: 'all',
    isLoadingData: false,
    viewType: 'normal'
  },
  reducers: {
    setThreads: (state, action) => {
      const threads = action.payload
      state.threads = Object.assign(state.threads, threads)
    },
    _setFilter: (state, action) => {
      const filter = action.payload
      state.currentFilter = filter
    },
    _setFilterMode: (state, action) => {
      const value = action.payload
      const mode = value ? 'unread' : 'all'
      state.filteringMode = mode
    },
    _setPages: (state, action) => {
      const pages = action.payload
      state.pages = Object.assign(state.pages, pages)
    },
    _setLoadingStatus: (state, action) => {
      const status = action.payload
      state.isLoadingData = status
    },
    _setThreadsCountBeforeHidingUI: (state) => {
      state.threadsCountBeforeHidingUI = Object.values(state.threads).length
    },
    updateThread: (state, action) => {
      const thread = action.payload
      state.threads[thread.composedid] = thread
    },
    _setViewType: (state, action) => {
      const status = action.payload
      state.viewType = status
    },
  }
})

export const { setThreads, updateThread, _setFilter, _setFilterMode, _setPages, _setLoadingStatus, _setThreadsCountBeforeHidingUI, _setViewType } = slice.actions

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state) => state.counter.value)`
export const selectCount = state => state.counter.value

export default slice.reducer
